import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchArticles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('customer/agent-articles', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteArticle(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`customer/agent-articles/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
